// utils/currency.js
export const convertFromUSD = (usdValue, targetCurrency) => {
  const rates = {
    USD: 1,
    EUR: 0.917,
    GBP: 0.782,
  };
  const rate = rates[targetCurrency] || 1;
  return Math.round(usdValue * rate);
};
